import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiUrl } from '@brand-lolly/app/_services/base-api-urls';
import { Observable } from 'rxjs';
import {
	DowngradeRequest,
	DowngradeResponse
} from '@brand-lolly/app/billing/types/mutations.types';
import { idempotencyHeaders } from './idempotency.util';

export interface IDowngradeSubscriptionService {
	downgrade(request: DowngradeRequest): Observable<DowngradeResponse>;
}

@Injectable({ providedIn: 'root' })
export class DowngradeSubscriptionService
	implements IDowngradeSubscriptionService
{
	private readonly url = `${BaseApiUrl.SocialMessengerPython}billing/downgrade`;

	constructor(private http: HttpClient) {}

	downgrade(request: DowngradeRequest): Observable<DowngradeResponse> {
		return this.http.post<DowngradeResponse>(this.url, request, {
			headers: idempotencyHeaders()
		});
	}
}
